module.exports = __webpack_public_path__ + "img/47_30.22b3cc72.png";